import React, { useState, useEffect } from 'react';
import './Toast.css';

// Module-level toast state (simple pub/sub)
let _setToast = null;

export function showToast(message, type = 'success') {
  _setToast?.({ message, type, id: Date.now() });
}

export default function Toast() {
  const [toast, setToast] = useState(null);
  _setToast = setToast;

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 3000);
    return () => clearTimeout(t);
  }, [toast]);

  if (!toast) return null;
  return (
    <div className={`toast toast-${toast.type}`} role="status" aria-live="polite">
      {toast.message}
    </div>
  );
}
